import { NoDataCard } from '@nile/components/src';
import envConfig from '@nile/home/src/Config/env';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';

const conversationTypeMap = {
  conversation: 'conversation',
  note: 'note'
};

const TicketConversationEmptyState = (props) => {
  const { mode } = props;
  switch (mode) {
    case conversationTypeMap.note:
      return (
        <div className="full-height flex jctr actr">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}svg/notes_empty_state.svg)`}
            text={<FormattedMessage id="ticket.details.notes.emptyState" />}
            description={
              <FormattedMessage id="ticket.details.notes.emptyState.description" />
            }
            type="secondary"
          />
        </div>
      );

    case conversationTypeMap.conversation:
      return (
        <div className="full-height flex jctr actr">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}svg/conversation-empty-state.svg)`}
            text={
              <FormattedMessage id="ticket.details.conversation.emptyState" />
            }
            description={
              <FormattedMessage id="ticket.details.conversation.emptyState.description" />
            }
            type="secondary"
          />
        </div>
      );
    default:
      return (
        <div className="full-height flex jctr actr">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}svg/updates-empty-state.svg)`}
            text={<FormattedMessage id="ticket.details.updates.emptyState" />}
            description={
              <FormattedMessage id="ticket.details.updates.emptyState.description" />
            }
            type="secondary"
          />
        </div>
      );
  }
};

export default withErrorBoundary(TicketConversationEmptyState);
